import type { MasonryGridProps } from "./masonry-grid.type";

import classNames from "classnames";
import Masonry from "react-masonry-css";

import "./masonry-grid.style.less";

export const MasonryGrid = ({
  items,
  className,
  ...masonryProps
}: MasonryGridProps) => {
  if (!items?.length) return null;

  return (
    <Masonry
      {...masonryProps}
      className={classNames("masonry-grid", className)}
      columnClassName="masonry-grid-column"
    >
      {items.map(({ key, node }) => (
        <div key={key} className="masonry-grid-item">
          {node}
        </div>
      ))}
    </Masonry>
  );
};
